// extracted by mini-css-extract-plugin
export default {"white":"public_white__hramp","root":"public_root__ergqV","wrapper":"public_wrapper__A+mnd"};